import { useCreate, useDelete, useGetAll, useGetOne, useUpdate } from "./crudService";

const endpoint:string = 'appeals';

export function useGetAllAppeals(params:{page:number}, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint], ...queryParams}, params);
}

export function useGetAppeal(id: number, params:any = {}) {
    return useGetOne({queryKey: [endpoint, id], ...params});
}

export function useCreateAppeal() {
    return useCreate({queryKey: [endpoint]});
}

export function useUpdateAppeal({id}) {
    return useUpdate({queryKey: [endpoint, id]});
}

export function useDeleteAppeal({id}) {
    return useDelete({queryKey: [endpoint, id]});
}
